import { render, staticRenderFns } from "./kurse.vue?vue&type=template&id=36cf9363&"
import script from "./kurse.vue?vue&type=script&lang=ts&"
export * from "./kurse.vue?vue&type=script&lang=ts&"
import style0 from "../assets/css/theme.css?vue&type=style&index=0&lang=css&"
import style1 from "../assets/css/style-sheet_registration.css?vue&type=style&index=1&lang=css&"
import style2 from "../assets/css/style-sheet_form.css?vue&type=style&index=2&lang=css&"
import style3 from "./kurse.vue?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports